import { render } from "./head.vue?vue&type=template&id=958e3e12&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=958e3e12&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958e3e12"]])

export default __exports__